import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Box, Grid } from '@mui/material';
import $ from "jquery";
import classNames from 'classnames';

export class Gallery extends Component {
  constructor(props){
    super(props);
    this.state = {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  }

  getItems() {
    const { filter, filterEnabled, items } = this.props;
    if ( !items ) {
      return [];
    }
    return filterEnabled && filter ? items.filter( filter ) : items;
  }
  

  updateDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };
  
  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const { itemTemplate, user } = this.props;
    const {width, height} = this.state;
    let itemHeight = width-(width*25/100);
    // if($('#galleryList').width()){
    //   itemHeight = $('#galleryList').width();
    // }
    console.log(width, height, itemHeight)
    const mdWidth = `${(width-(width*25/100)-100)*25/100}px`
    const xsWidth = `${(width-49)*50/100}px`
    const Template = itemTemplate;
    const items = this.getItems();
    const tiles = items.map( ( item, key ) =><Grid item className={classNames("tile",{"dk":user?.country.toLowerCase()==="dk"||user?.country.toLowerCase()==="dkcbol"})} width={{xs:xsWidth, md:mdWidth}} height={{md:user?.country.toLowerCase()==="dk"||user?.country.toLowerCase()==="dkcbol"?"230px":mdWidth, xs:xsWidth, lg:mdWidth}} margin={{md:"0px", xs:"0px"}} 
    >
      <Template item={ item } key={ key }/></Grid>);

    return(
      <Grid item container sx={{height:"100%", width:"100%", marginLeft:{md:"20px"},marginTop:{md:"22px", xs:"0px"}, overflowY:{md:"hidden", xs:"auto"}, overflowX:"hidden"}}>
        <Grid item container md={12} sx={{height:{md:"100%", xs:"auto"},scrollMarginTop: "20px"}}>
          <div className="gallery">
            <div className="gallery-list" id="galleryList">
              <Grid item container xs={12} md={12} gap={{md:"20px", xs:"15px"}}>
                { tiles }
              </Grid>    
            </div>
          </div>
        </Grid>
        <Grid item xl={1.5}></Grid>
      </Grid>
    )
  }
}

Gallery.propTypes = {
  filter: PropTypes.func,
  filterEnabled: PropTypes.bool,
  itemTemplate: PropTypes.oneOfType( [PropTypes.node, PropTypes.func, PropTypes.elementType] ).isRequired,
};